module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/holes/door/door.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/holes/door/door.png
// module id = 475
// module chunks = 0